import Vue from 'vue';
import FrameComponent from './frame.vue';

const FrameVueConstructor = Vue.extend(FrameComponent);

const instance = new FrameVueConstructor({
  el: document.createElement('div'),
});

document.body.appendChild(instance.$el);

const frame = {
  show(options) {
    instance.show = true;
    instance.src = options.src;
    // eslint-disable-next-line
    instance.type = (options.type || 'image/').split('/')[0];
  },
}

export default frame;
